import { Box, Card, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import DataHandlerTable from "src/components/data-handler/table";
import ParseDate from "src/components/date";
import Map from "src/components/map";
import PaginationButtons from "src/components/pagination";
import { Currency } from "src/components/with-prefix";
import Ternary from "src/components/ternary";
import { PATH_DASHBOARD, PATH_USER } from "src/routes/paths";
import useMyOrders from "../onlineStore/myOrders/hooks/useMyOrders";
import usePrescriptionList from "./hooks/usePrescriptionList";
import useAuth from "src/hooks/useAuth";
import DataFilter from "./components/filter";
import useFilter from "./hooks/use-filter";
import { capitalCase } from "change-case";

const headers = [
  "consultation.no",
  "consultation.date",
  "consultation.status",
  "consultation.prescriptions",
];

const PrescriptionList = () => {
  const methods = useFilter();
  const filter = methods.watch();
  const { user } = useAuth();
  const userId = user?.id;
  const { state, fetchData, rowStart, ...rest } = usePrescriptionList(
    userId,
    filter
  );
  const { data, ...dataProps } = state;
  const onFilter = methods.handleSubmit(async (inputData) => {
    await fetchData(1, inputData);
  });
  return (
    <Page title={"consultation.prescriptions"}>
      <HeaderBreadcrumbs
        heading="consultation.prescriptions"
        links={[
          { name: "global.dashboard", href: PATH_DASHBOARD.root },
          { name: "consultation.prescriptions" },
        ]}
      />
      <Card sx={{ pt: 1 }}>
        <DataFilter methods={methods} onFilter={onFilter} />
        <Scrollbar>
          <DataHandlerTable
            name="prescriptions-table"
            headers={headers}
            dataProps={{ ...dataProps }}
          >
            <Map
              list={data}
              render={(row, i) => (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {i + rowStart}
                  </TableCell>
                  <TableCell>
                    {" "}
                    <ParseDate date={row?.created_at} />{" "}
                  </TableCell>
                  <TableCell>{capitalCase(row?.status || "")}</TableCell>
                  <TableCell>{row?.prescription}</TableCell>
                </TableRow>
              )}
            />
          </DataHandlerTable>
        </Scrollbar>
      </Card>
      <PaginationButtons {...rest} />
    </Page>
  );
};

export default PrescriptionList;
